import { render } from "./MainSearchForm.vue?vue&type=template&id=2c52f306"
import script from "./MainSearchForm.vue?vue&type=script&lang=js"
export * from "./MainSearchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__